import { SET } from "@/stores/CommumActionTypes";

const actions = {
	[SET]: ({ commit }, value) =>
	{
		commit(SET, value);
	},
};

export default { actions };
